import Swal from "sweetalert2";
import { const_routes } from "../helpers/const_routes";
import { fetchToken } from "../helpers/fetch";
import { types } from "../types/types";
import { startLogout } from "./authActions";
import { t } from "i18next";
import { debugErrorActions, debugLogActions } from "../helpers/debugHelper";
import { startRegisterSearchResult } from "./searchResultActions";
import { dispatchSearchFilterResults } from "../helpers/searchFilterDispatch.helper";
import { resolveFlowListQueryFromState } from "../helpers/flowModuleListQueryHelper";

export const assistanceStartRegisterAdmin = (assistance, navigate, returnTo) => {
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_ASSISTANCE}`,
      "add",
      assistance,
      "POST"
    );

    const body = await resp.json();

     debugLogActions(':: assistanceActions, assistanceStartRegisterAdmin', { 'body': body });

    if (body.ok) {

      const assistanceSaved = body.assistance;

      dispatch(assistanceRegisterAdmin(assistanceSaved));

      Swal.fire({
        title: t("titles.success"),
        text: t("record.save"),
        icon: 'success',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        confirmButtonText: t("buttons.close")
      }).then((result) => {
        if (result.isConfirmed) {
          setTimeout(() => {
            const nextPath = typeof returnTo === "string" && returnTo.startsWith("/")
              ? returnTo
              : "/specialist-assistance";
            navigate(nextPath);
          }, 5000);
        }
      });

    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  }
};

const assistanceRegisterAdmin = (assistance) => ({
  type: types.ASSISTANCE_START_REGISTER_ADMIN,
  payload: assistance,
});

export const assistanceStartUpdate = (assistance, navigate) => {
  return async (dispatch) => {
    try {
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_ASSISTANCE}`,
        `update/${assistance.id}`,
        assistance,
        "PUT"
      );
      const body = await resp.json();

       debugLogActions(':: assistanceActions, assistanceStartUpdate', { 'body': body });

      if (body.ok) {
        dispatch(assistanceUpdated(assistance));

        Swal.fire({
          title: t("titles.success"),
          text: t("record.update"),
          icon: 'success',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          confirmButtonText: t("buttons.close")
        });

      } else {

        if (body.errors) {
          debugLogActions("inside errors", body.errors);
          const { catalogserie_id } = body.errors;

          if (catalogserie_id) {
            Swal.fire(t("titles.error"), catalogserie_id.msg, "error");
            
          }
        }

        if (body.code === "bak-error-001") {
           Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
          
        }
        if (body.code === "bak-aut-tok-inv-001") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-001"), "error");
          dispatch(startLogout());
        }
        if (body.code === "bak-aut-tok-inv-002") {
          Swal.fire(t("titles.error"), t("api.token.timed_out"), "error");
          dispatch(startLogout());
        }
      }
    } catch (error) {
      debugErrorActions(':: assistanceActions, assistanceStartUpdate', { 'error': error });
    }
  };
};

const assistanceUpdated = (assistance) => {
  return {
    type: types.ASSISTANCE_UPDATE,
    payload: assistance,
  };
};

export const assistanceStartDelete = (id, onDeleted) => {
  return async (dispatch, getState) => {
    try {
      await Swal.fire({
        title: t("record_delete.title"),
        text: t("record_delete.text"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: t("titles.delete"),
      }).then((result) => {
        if (result.isConfirmed) {
          fetchToken(
            `${const_routes.SCHEMA}`,
            `${const_routes.VERSIONV1}`,
            `${const_routes.ROUTE_ASSISTANCE}`,
            `delete/${id}`,
            { deleted: false },
            "DELETE"
          )
            .then((resp) => resp.json())
            .then((body) => {

               debugLogActions(':: assistanceActions, assistanceStartDelete', { 'body': body });

              if (body.ok) {
                dispatch(assistanceDeleted(id));
                if (typeof onDeleted === "function") {
                  onDeleted();
                }
              } else {
                if (body.code === "bak-error-001") {
                   Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
                  
                }
                if (body.code === "bak-aut-tok-inv-001") {
                  Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
                  dispatch(startLogout());
                }
                if (body.code === "bak-aut-tok-inv-002") {
                  Swal.fire(t("titles.error"), t("api.token.timed_out"), "error");
                  dispatch(startLogout());
                }
              }
            });
          Swal.fire(t("titles.success"), t("record.delete"), "success");
        }
      });
    } catch (error) {
      debugErrorActions(':: assistanceActions, assistanceStartDelete', { 'error': error });
    }
  };
};

const assistanceDeleted = (id) => {
  return {
    type: types.ASSISTANCE_DELETE,
    payload: id,
  };
};

export const startLoadingAssistancesPaginated = (page, size) => {
  return async (dispatch, getState) => {
    const query = resolveFlowListQueryFromState(getState, 'assistance');
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_ASSISTANCE}`, `get/${page}/${size}${query}`);
    const body = await resp.json();

    debugLogActions(':: assistanceActions, startLoadingAssistancesPaginated', { 'body': body });

    if (body.ok) {
      dispatch(loadingAssistancesPaginated(body.assistancesPaginated));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingAssistancesPaginated = (assistancesPaginated) => ({
  type: types.ASSISTANCE_START_LOADING_PAGINATED,
  payload: assistancesPaginated,
});

export const startLoadingAssistancesByTextAssistancePaginated = (assistance, page, size, catalogToFilter, indicatorToFilter = [], codeCiiuLevel1={}) => {
  return async (dispatch, getState) => {

      const searchInfo = {
      searchAssistanceText: assistance,
      codeCiiuLevel1: codeCiiuLevel1,
      catalogToFilter: catalogToFilter,
      indicatorToFilter: indicatorToFilter,
    };

    dispatch(assistanceIsLoading());

    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_ASSISTANCE}`,
      `getByTextAssistance/${page}/${size}`,
      searchInfo,
      "POST"
    );
    const body = await resp.json();

     debugLogActions(':: assistanceActions, startLoadingAssistancesByTextAssistancePaginated', { 'body': body });

    if (body.ok) {

      dispatch(assistanceIsLoadingFinish());

      dispatchSearchFilterResults(dispatch, body.filterResults, {
        withSectionPhase: false,
        withInstitution: true,
      });

      body.assistancesPaginated.assistancesP.forEach(element => {
        element.isSelected = false;
        element.isCompared = false;
      });

      dispatch(loadingAssistancesByTextAssistancePaginated(body.assistancesPaginated));

      const { totalItems, totalPages, currentPage, assistancesP } = body.assistancesPaginated;
      
            let index = 0;
            let registerIds = "";
            assistancesP.forEach(element => {
      
              if (index === 0) {
                registerIds = registerIds.concat(element.id);
              } else {
                registerIds = registerIds.concat(";", element.id);
              }
      
              index = index + 1;
            });
      
            const state = getState();
            const { searchInfo } = state.searchInfo;
      
            const searchResult = {
              filter_results: body.filterResults,
              total_items: totalItems,
              total_pages: totalPages,
              current_page: currentPage,
              search_results_ids: registerIds,
              deleted: false,
              searchinfo_id: searchInfo.id
            }
      
            dispatch(startRegisterSearchResult(searchResult));

    } else {

      dispatch(assistanceIsLoadingFinish());
      
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  }
};

const loadingAssistancesByTextAssistancePaginated = (assistancesPaginated) => ({
  type: types.ASSISTANCE_START_LOADING_ASSISTANCE_PAGINATED,
  payload: assistancesPaginated,
});

export const startSearchingAssistancesPaginated = (textSearch, page, size) => {
  
  return async (dispatch, getState) => {
    const query = resolveFlowListQueryFromState(getState, 'assistance');
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_ASSISTANCE}`,
      `search/${textSearch}/${page}/${size}${query}`
    );
    const body = await resp.json();

     debugLogActions(':: assistanceActions, startSearchingAssistancesPaginated', { 'body': body });

    if (body.ok) {
      dispatch(searchingAssistancesPaginated(body.assistancesPaginated));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  }
};

const searchingAssistancesPaginated = (assistancesPaginated) => ({
  type: types.ASSISTANCE_START_SEARCH_PAGINATED,
  payload: assistancesPaginated,
});

export const selectAssistance = (assistance) => ({
  type: types.ASSISTANCE_SELECT,
  payload: assistance,
});

export const cleanAssistancesPaginatedS = () => ({
  type: types.ASSISTANCE_CLEAN_SEARCH_PAGINATED,
});

export const cleanAssistancesPaginatedP = () => ({
  type: types.ASSISTANCE_CLEAN_PAGINATED,
});

export const assistanceSetSearchText = (searchText) => ({
  type: types.ASSISTANCE_SET_SEARCH_TEXT,
  payload: searchText,
});

export const assistanceCleanSearchText = () => ({
  type: types.ASSISTANCE_CLEAN_SEARCH_TEXT,
});

export const assistanceCleanSaved = () => ({
  type: types.ASSISTANCE_CLEAN_SAVED,
});

//Si van 13 de Feb 2026
export const assistanceListUpdateSelected = (id) => ({
  type: types.ASSISTANCE_LIST_UPDATE_SELECTED,
  payload: id
});

export const assistanceListSelectAllLimit = () => ({
  type: types.ASSISTANCE_SELECT_ALL_LIMIT,
});

export const assistanceCleanAllSelected = () => ({
  type: types.ASSISTANCE_CLEAN_ALL_SELECTED,
});

export const assistanceCleanAllSelectedWithoutList = () => ({
  type: types.ASSISTANCE_CLEAN_ALL_WITHOUT_LIST,
});

export const assistanceIsLoading = () => ({
  type: types.ASSISTANCE_IS_LOADING
});

export const assistanceIsLoadingFinish = () => ({
  type: types.ASSISTANCE_IS_LOADING_FINISH
});

//No van Update 13 de Feb 2026
export const assistanceGetMoreThanOneIsSelected = () => ({
  type: types.ASSISTANCE_GET_MORE_THAN_ONE_SELECTED
});

export const assistanceGetNumberAssistanceSelected = (countCompareFlag) => ({
  type: types.ASSISTANCE_LIST_SET_NUMBER_SELECTED,
  payload: countCompareFlag
});

export const cleanSearchInformation = () => ({
  type: types.ASSISTANCE_CLEAN_SEARCH_INFORMATION,
});
